module.exports = __webpack_public_path__ + "static/media/Tianyi Zhou.9a221c50.png";